module.exports = __webpack_public_path__ + "img/external-contt.duckduckgo.com.f58191d9.png";